export type PhaseState = 'complete' | 'started' | 'not-started' | 'progress' | 'review' | 'error';
export type ProgressColor = 'success' | 'progress' | 'empty' | 'review' | 'error';

export const mapPhaseStateToColor = (state: PhaseState): ProgressColor => {
  const stateColorMap: Record<PhaseState, ProgressColor> = {
    'complete': 'success',
    'started': 'progress',
    'progress': 'progress',
    'not-started': 'empty',
    'review': 'review',
    'error': 'error'
  };

  return stateColorMap[state] || 'empty';
};